var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.requisitionPickUpText && !_vm.isDemoUser)?_c('div',{staticClass:"RequisitionPickUpNotice",domProps:{"innerHTML":_vm._s(_vm.requisitionPickUpText)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }